import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export const fetchInStock = createAsyncThunk(
  "InStock/fetchInStock",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    const filterPayload = FilterBuilder(filters ?? []);
    const body = {
      filters: filterPayload,
    };

    const response: any = await WarehouseAxios.post(
      `${API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.IN_STOCK.LIST(warehouse_id)}&${params.toString()}`,
      body
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportInStockCSV = async ({
  warehouse_id,
  search,
  filters,
}: {
  warehouse_id: string;
  search?: string;
  filters?: any[];
}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);
  const body = {
    filters: filterPayload,
  };

  const response = await WarehouseAxios.post(
    `${API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.IN_STOCK.EXPORT(warehouse_id)}&${params.toString()}`,
    body,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `Warehouse_instock_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

export const fetchInStockFilterDropdown = createAsyncThunk(
  "InStock/fetchInStockFilterDropdown",
  async (
    {
      warehouse_id,
      field,
    }: {
      warehouse_id: string;
      field: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await WarehouseAxios.get(
        API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.IN_STOCK.DROPDOWN(field, warehouse_id)
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch dropdown data"
      );
    }
  }
);

